import angular from "angular";
import { ApiClient } from "@topline/services/apiService";
import { ProductOwnersComponent } from "./productOwners.component";
import { angularServicesNames } from "@topline/services/angularServicesNames";

class ProductOwnersConfig {
    static $inject = ["$stateProvider"];

    constructor(private $stateProvider: ng.ui.IStateProvider) {
        this.init();
    }

    private init() {
        this.$stateProvider
            .state("productOwners", {
                abstract: true,
                resolve: {
                    translateReady: [angularServicesNames.$translate, ($translate: ng.translate.ITranslateService) => $translate.onReady()]
                }
            })
            .state("productOwners.config", {
                url: "^/product-owners/config",
                component: ProductOwnersComponent.componentName,
                resolve: {
                    budgetVersions: [
                        ApiClient.componentName,
                        (apiClient: ApiClient) => apiClient.getBudgetVersionsForDate(new Date())
                    ]
                }
            });
    }
}

angular.module("topline.modules").config(ProductOwnersConfig);
